export default __webpack_public_path__ + "static/media/adyen.1efe64f8.svg";